// Feature switches. Parked features keep their code and tests so they can be
// re-enabled by flipping a flag; while off, they're hidden from the UI and
// their routes show "not found".
export const FEATURES = {
  /** "My Briefing" page and the basket's "Build my briefing" button. */
  briefing: false,
  /**
   * Audience filter on Browse. Off until editors have confirmed audience tags
   * (imports only carry suggestions). While off, a saved audience is ignored.
   */
  audienceFilter: false,
  /** Digest home page (themes per period). Off = Browse is the home page. */
  digest: false,
  /** Optional Google sign-in and account sync. Off = guest-only (this device). */
  signIn: false,
} as const;
